export const CHECKOUT_HANDOFF_MODES = Object.freeze({
  CURBSIDE: 'CURBSIDE',
  PICKUP: 'PICKUP',
  DELIVERY: 'DELIVERY',
})
